import { render, staticRenderFns } from "./mfooter.vue?vue&type=template&id=65b4128c&scoped=true&"
import script from "./mfooter.vue?vue&type=script&lang=js&"
export * from "./mfooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b4128c",
  null
  
)

export default component.exports